export default __webpack_public_path__ + "static/media/talent_main-section-logo-coty-Dev-IT.7ae8aeec.svg";